import React, { useState } from 'react';
import { Link } from "react-router-dom";
import AppWrapper from '../layout/AppWrapper';
import AllPackages from '../components/user/packages/AllPackages';
import { useUserContext } from '../context/user_context';
import { Button } from '../styles';

const NoUserAccess = () => {

  const { usertoken, businessData } = useUserContext();
  const ownerToken = businessData?.owner_token;


  return (
    <>
      <AppWrapper
        pagename={"dashboard"}
        route={"upgrade"}
      >
        {ownerToken === usertoken ?
          <section className="">
            <div className=" text-center">
              <h5 className="pry-text"> This Business is Inactive </h5>
              <div className="d-flex align-items-center justify-content-center" >
                <Link to="/user/settings/billing">
                  <Button pry className="btn mt-3"> Upgrade Business </Button>
                </Link>
              </div>
              <AllPackages />
            </div>
          </section>

          :
          <section className="">
            <div className=" text-center display-2">
              NO ACCESS !!!
            </div>

            <div className=" text-center">
              <h5 className="pry-text"> This Business is Inactive </h5>
              <div className="d-flex align-items-center justify-content-center" >
                <Link to="#">
                  <Button pry className="btn mt-3"> Contact Business Admin </Button>
                </Link>
              </div>
            </div>
          </section>
        }
      </AppWrapper>
    </>
  );
};

export default NoUserAccess;
